import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Bot, ArrowLeft } from "lucide-react";

export function FullscreenChat() {
  const navigate = useNavigate();

  useEffect(() => {
    // Rediriger automatiquement vers la page d'accueil après 3 secondes
    const timer = setTimeout(() => {
      navigate('/');
    }, 3000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-purple-50 flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-xl p-8 text-center">
        <div className="w-20 h-20 bg-gradient-to-r from-blue-500 to-purple-500 rounded-full flex items-center justify-center mx-auto mb-6">
          <Bot className="w-10 h-10 text-white" />
        </div>
        
        <h1 className="text-2xl font-bold text-gray-800 mb-4">
          Chat Adha Modernisé !
        </h1>
        
        <p className="text-gray-600 mb-6 leading-relaxed">
          L'assistant Adha est maintenant disponible sur toutes les pages ! 
          Regardez en bas à droite de votre écran pour commencer à discuter.
        </p>

        <div className="space-y-3 mb-6">
          <div className="flex items-center gap-3 text-sm text-gray-500">
            <div className="w-2 h-2 bg-green-500 rounded-full"></div>
            Assistant IA disponible partout
          </div>
          <div className="flex items-center gap-3 text-sm text-gray-500">
            <div className="w-2 h-2 bg-blue-500 rounded-full"></div>
            Interface modernisée et élégante
          </div>
          <div className="flex items-center gap-3 text-sm text-gray-500">
            <div className="w-2 h-2 bg-purple-500 rounded-full"></div>
            Réponses plus intelligentes
          </div>
        </div>

        <button
          onClick={() => navigate('/')}
          className="inline-flex items-center gap-2 bg-gradient-to-r from-blue-500 to-purple-500 text-white px-6 py-3 rounded-xl hover:from-blue-600 hover:to-purple-600 transition-all duration-200"
        >
          <ArrowLeft className="w-4 h-4" />
          Retour à l'accueil
        </button>

        <p className="text-xs text-gray-400 mt-4">
          Redirection automatique dans 3 secondes...
        </p>
      </div>
    </div>
  );
}
